import 'css-chunksrc/feature/check-print/CheckDetailPrintCheckBox.module.scss';export default {
  "root": "CheckDetailPrintCheckBox_root",
  "icon": "CheckDetailPrintCheckBox_icon",
  "checked": "CheckDetailPrintCheckBox_checked"
};